import styled, { css } from 'styled-components';
import { breakpoints, colors } from '@chegg-ui/theme';
import { CardTypes } from '../../constants/PaymentTypes';
export var getCardStyles = function getCardStyles(props) {
  var cardType = props.cardType,
    cdnUrl = props.cdnUrl;
  switch (cardType) {
    case CardTypes.AMERICANEXPRESS:
    case CardTypes.AMEX:
      return css(["background-image:url('", "site/logos/American-Express-01.svg');background-size:47px 47px;@media (max-width:", "){background-size:36px 36px;}"], cdnUrl, breakpoints.sm.max);
    case CardTypes.MASTERCARD:
      return css(["background-image:url('", "site/logos/MC-01.svg');background-size:30px 30px;@media (max-width:", "){background-size:25px 25px;}"], cdnUrl, breakpoints.sm.max);
    case CardTypes.VISA:
      return css(["background-image:url('", "site/logos/Visa.svg');background-size:30px 12px;@media (max-width:", "){background-size:32px 9px;}"], cdnUrl, breakpoints.sm.max);
    case CardTypes.DISCOVER:
      return css(["background-image:url('", "site/logos/Discover-Card-01.svg');background-size:60px 60px;@media (max-width:", "){background-size:47px 47px;}"], cdnUrl, breakpoints.sm.max);
    case CardTypes.JCB:
      return css(["background-image:url('", "site/logos/jcb-logo.svg');background-size:30px 30px;"], cdnUrl);
    case CardTypes.PAYPAL:
      return css(["background-image:url('", "site/logos/PayPal-lg.svg');background-size:37px 12px;@media (max-width:", "){background-size:30px;}"], cdnUrl, breakpoints.sm.max);
    case CardTypes.APPLEPAY:
      return css(["background-image:url('", "site/logos/Apple_Pay_Mark_RGB_041619.svg');background-size:51px;"], cdnUrl);
    case CardTypes.VENMO:
      return css(["background-image:url('", "site/logos/Venmo_Icon.svg');background-size:47px;"], cdnUrl);
    case CardTypes.GIFTCODE:
      return css(["background-image:url('", "site/logos/chegg-giftcard-logo.svg');background-size:48px 48px;"], cdnUrl);
    case CardTypes.GOOGLEPAY:
      return css(["background-image:url('", "site/logos/GooglePay.svg');background-size:43px;padding:0px 2px;@media (max-width:", "){background-size:37px 20px;}"], cdnUrl, breakpoints.sm.max);
    case CardTypes.RUPAY:
      return css(["background-image:url('", "site/logos/Rupay-Icon.png');background-size:40px 11px;@media (max-width:", "){background-size:32px;}"], cdnUrl, breakpoints.sm.max);
    case CardTypes.DINERSCLUB:
      return css(["background-image:url('", "site/logos/Diners-Icon.png');background-size:31px 22px;@media (max-width:", "){background-size:25px;}"], cdnUrl, breakpoints.sm.max);
    case CardTypes.UNIONPAY:
      return css(["background-image:url('", "site/logos/union-pay-logo.svg');background-size:31px 22px;@media (max-width:", "){background-size:25px;}"], cdnUrl, breakpoints.sm.max);
    default:
      return null;
  }
};
export var CardLogoImg = styled.div.withConfig({
  componentId: "sc-1pg9v9g-0"
})(["display:inline-block;background-color:#fff;background-repeat:no-repeat;background-position:center center;border:", ";border-radius:4px;width:43px;height:25px;opacity:", ";", ";flex-shrink:0;@media (max-width:", "){width:37px;height:20px;}"], function (props) {
  return props.cardType == CardTypes.GOOGLEPAY ? 'none' : props.isMopContainer ? '1px solid #3b4043' : "1px solid ".concat(colors.greyMedlight);
}, function (props) {
  return props.valid ? 1 : 0.2;
}, function (props) {
  return getCardStyles(props);
}, breakpoints.sm.max);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/CardLogo/styled.js
// module id = 4544
// module chunks = 11